import { Text, View } from '@react-pdf/renderer';

import { getFeeArrangementFees } from '../../../clientDetails/components/contractArrangementsTab';
import { IInvoicePdf } from '../../types/IInvoicePdf';
import {
  getContractPlacementSellRate,
  getContractPlacementUnits,
} from '../invoiceDetails/InvoiceDetailContractPlacementDetails';
import { InvoiceTemplate } from '../InvoiceTemplateForm';

import styles from './Styles';
export const Description = ({
  invoice,
  tabular,
  template,
}: {
  invoice: IInvoicePdf;
  tabular: boolean;
  template?: InvoiceTemplate;
}) => {
  const {
    currency: invoiceCurrency,
    items,
    lineItems,
    placementType,
    showSellRateAndUnits,
  } = invoice;
  const showCompensation =
    invoice.showCompensationFeeArr && (template?.descriptionCandidateCompensation ?? true);
  const showFeeArr =
    invoice.showCompensationFeeArr && (template?.descriptionCandidateFeeArrangement ?? true);

  return (
    <View style={styles.invoice_table}>
      <View style={styles.table_header}>
        <Text style={{ width: '8%' }}>S. No.</Text>
        {placementType === 'PERMANENT' ? (
          <>
            <Text style={{ width: tabular && (showCompensation || showFeeArr) ? '30%' : '70%' }}>
              Description
            </Text>
            {tabular && (showCompensation || showFeeArr) && (
              <>
                {showCompensation && (
                  <Text style={{ width: '20%', textAlign: 'center' }}>Compensation</Text>
                )}
                {showFeeArr && (
                  <Text style={{ width: '20%', textAlign: 'center' }}>Fee Arrangement</Text>
                )}
              </>
            )}
            <Text style={{ width: '20%', textAlign: 'center' }}>Amount</Text>
          </>
        ) : (
          <>
            <Text style={{ width: tabular && showSellRateAndUnits ? '30%' : '70%' }}>
              Description
            </Text>
            {tabular && showSellRateAndUnits && (
              <>
                <Text style={{ width: '20%', textAlign: 'center' }}>Rate</Text>
                <Text style={{ width: '20%', textAlign: 'center' }}>Units</Text>
              </>
            )}
            <Text style={{ width: '20%', textAlign: 'center' }}>Amount</Text>
          </>
        )}
      </View>
      {placementType === 'PERMANENT'
        ? items?.map((item, index) => {
            const compensationAmount = item.closure?.compensationAmount;
            const currency = invoiceCurrency?.symbol ?? '';

            return (
              <View style={styles.table_row} key={index}>
                <Text style={{ width: '8%' }}>{index + 1}</Text>
                <Text
                  style={{ width: tabular && (showCompensation || showFeeArr) ? '30%' : '70%' }}
                >
                  {item.type !== 'INVOICE_EXTRA'
                    ? `Fee for Placement of ${item.closure?.candidate?.name}. ${
                        !tabular
                          ? invoice.showCompensationFeeArr
                            ? getFeeArrangementFees(item.closure?.feeArrangement) +
                              ` Fee Arrangement of ${currency} ${compensationAmount}.`
                            : ''
                          : ''
                      }`
                    : item.invoiceExtraCharge?.description}
                </Text>
                {tabular && (
                  <>
                    <Text style={{ width: '20%', textAlign: 'center' }}>
                      {item.type === 'INVOICE_EXTRA'
                        ? ''
                        : showCompensation &&
                          (invoiceCurrency?.symbol ?? '') + item.closure?.compensationAmount}
                    </Text>
                    <Text style={{ width: '20%', textAlign: 'center' }}>
                      {item.type === 'INVOICE_EXTRA'
                        ? ''
                        : showFeeArr && getFeeArrangementFees(item.closure?.feeArrangement)}
                    </Text>
                  </>
                )}
                <Text style={{ width: '20%', textAlign: 'center' }}>
                  {`${invoiceCurrency?.symbol ?? ''} ${
                    item.type !== 'INVOICE_EXTRA'
                      ? item.closure?.commissionValue
                      : item.invoiceExtraCharge?.amount
                  }`}
                </Text>
              </View>
            );
          })
        : lineItems?.map((item, index) => (
            <View style={styles.table_row} key={index}>
              <Text style={{ width: '8%' }}>{index + 1}</Text>
              <Text style={{ width: tabular && showSellRateAndUnits ? '30%' : '70%' }}>
                {item.type === 'CLOSURE'
                  ? `${item.contractPlacement?.candidate?.name}`
                  : item.description}
              </Text>
              {tabular && showSellRateAndUnits && (
                <>
                  <Text style={{ width: '20%', textAlign: 'center' }}>
                    {item.type === 'CLOSURE'
                      ? getContractPlacementSellRate(item.contractPlacement)
                      : ''}
                  </Text>
                  <Text style={{ width: '20%', textAlign: 'center' }}>
                    {item.type === 'CLOSURE' ? getContractPlacementUnits(item) : ''}
                  </Text>
                </>
              )}
              <Text style={{ width: '20%', textAlign: 'center' }}>
                {`${invoiceCurrency?.symbol ?? ''} ${item.amount}`}
              </Text>
            </View>
          ))}
    </View>
  );
};
